module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/account/user-widget-selection/user-widget-selection.component.scss
// module id = ./src/app/components/account/user-widget-selection/user-widget-selection.component.scss
// module chunks = main